import { v4 as uuidv4 } from 'uuid';

export default function generate_unique_id() {
    return uuidv4();
}

